import request from './base';

const JobFairApi = {
    /**
     *  获取校招(宣传页)-列表 (Auth)
     * @param name
     * @param pageIndex
     * @param pageSize
     * @returns {Promise | Promise<unknown>}
     */
    getPageList: ({name, pageIndex = 1, pageSize = 10}) => {
        return request.get('JobFair/GetPageList', {
            name,
            pageIndex,
            pageSize
        })
    },

    /**
     * 校招(宣传页)-详情数据 (Auth)
     * @param id
     * @returns {Promise | Promise<unknown>}
     */
    getDetail: (id) => {
        return request.get('JobFair/Get', {
            id
        })
    },

    /**
     * 校招(宣传页)-创建or简单修改(改名、改主题) (Auth)
     * @param id
     * @param name
     * @param themeCode
     * @returns {Promise | Promise<unknown>}
     */
    createUpdateJobFair: ({id, name = '', themeCode}) => {
        return request.post('JobFair/SimpleEdit', {
            id,
            name,
            themeCode
        })
    },

    /**
     * 校招(宣传页)-详细修改(改名、改主题除外) (Auth)
     * @param id
     * @param bannerPc
     * @param bannerWap
     * @param processPc
     * @param processWap
     * @param chargeShow
     * @param chargePc
     * @param chargeWap
     * @param reviewShow
     * @param video
     * @param img1
     * @param img2
     * @param img3
     * @param img4
     * @param img5
     * @param img6
     * @param img7
     * @param contactUsPc
     * @param contactUsWap
     * @param partLink
     * @returns {Promise<unknown>}
     */
    updateJobFair: ({id,bannerPc,bannerWap,processPc,processWap,chargeShow,chargePc,chargeWap,
                        reviewShow,video,img1,img2,img3,img4,img5,img6,img7, contactUsPc, contactUsWap, partLink})=>{
        return request.post('JobFair/Edit', {
            id,
            bannerPc,bannerWap,processPc,processWap,chargeShow,chargePc,chargeWap,
            reviewShow,video,img1,img2,img3,img4,img5,img6,img7, contactUsPc, contactUsWap, partLink
        })
    },

    /**
     * 校招(宣传页)-复制 (Auth)
     * @param id
     * @returns {Promise | Promise<unknown>}
     */
    copyJobFair: ({id}) => {
        return request.post('JobFair/Copy', {
            id
        })
    },
    /**
     * 校招(宣传页)-复制 (Auth)
     * @param id
     * @returns {Promise | Promise<unknown>}
     */
    deleteJobFair: ({id}) => {
        return request.delete('JobFair/Delete', {
            id
        })
    },


    /**
     * 线路(分类标签)-编辑 (Auth)
     * @param id
     * @param jobFairId
     * @param name
     * @param sort
     * @param remarkPc
     * @param remarkWap
     * @param layout
     * @returns {Promise | Promise<unknown>}
     */
    addJobFairLine: ({id, jobFairId, name, sort, remarkPc='', remarkWap='', layout}) => {
        return request.post('JobFair/LabelEdit', {
            id, jobFairId, name, sort, remarkPc, remarkWap, layout
        })
    },

    /**
     * 线路(分类标签)-删除 (Auth)
     * @param id
     * @returns {Promise | Promise<unknown>}
     */
    deleteJobFairLine: (id, jobFairId) => {
        return request.delete('JobFair/LabelDelete', {
            id,
            jobFairId
        })
    },

    /**
     * 招聘学校-编辑 (Auth)
     * @param id
     * @param jobFairId
     * @param jobFairLabelId
     * @param schoolName
     * @param studentNumber
     * @param lectureTime
     * @param hireTime
     * @param address
     * @param coverImg
     * @param downloadLink
     * @returns {Promise | Promise<unknown>}
     */
    addJobFairSchool: ({id, jobFairId, jobFairLabelId, schoolName, studentNumber, lectureTime, hireTime, address,
                           coverImg='', downloadLink=''})=>{
        return request.post('JobFair/SchoolEdit', {
            id, jobFairId, jobFairLabelId, schoolName, studentNumber, lectureTime, hireTime, address,
            coverImg, downloadLink
        })
    },

    /**
     * 招聘学校排序-编辑 (Auth)
     * @param id
     * @param sort
     * @returns {Promise | Promise<unknown>}
     */
    updateJobFairSchoolSort: ({id, sort})=>{
        return request.post('JobFair/SchoolSortEdit', {
            id, sort
        })
    },

    /**
     * 招聘学校-删除 (Auth)
     * @param id
     * @param jobFairId
     * @param jobFairLabelId
     * @returns {Promise<unknown>}
     */
    deleteJobFairSchool: ({id, jobFairId, jobFairLabelId})=>{
        return request.delete('JobFair/SchoolDelete', {
            id, jobFairId, jobFairLabelId
        })
    },

}


export default JobFairApi
